export default __webpack_public_path__ + "static/media/savanna_background.1590c170.svg";